"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Merchant = void 0;
const CardName_1 = require("../../CardName");
const constants_1 = require("../../constants");
class Merchant {
    constructor() {
        this.name = 'Merchant';
        this.description = 'Have at least 2 of each standard resource';
    }
    getScore(player) {
        if (player.cardIsInEffect(CardName_1.CardName.VAN_ALLEN) || player.isCorporation(CardName_1.CardName.NIRGAL_ENTERPRISES)) {
            return Math.min(player.megaCredits, player.steel, player.titanium, player.plants, player.energy, player.heat);
        }
        let score = Math.min(player.megaCredits - constants_1.MILESTONE_COST, player.steel, player.titanium, player.plants, player.energy, player.heat);
        if (player.canUseHeatAsMegaCredits) {
            if (player.megaCredits < 2 || player.heat < 2) {
                return Math.min(player.megaCredits, player.steel, player.titanium, player.plants, player.energy, player.heat);
            }
            if (player.megaCredits + player.heat >= 12) {
                let maxMegacreditsSpendable = player.megaCredits;
                if (player.megaCredits - constants_1.MILESTONE_COST < 2) {
                    maxMegacreditsSpendable = player.megaCredits - 2;
                    const balance = 8 - maxMegacreditsSpendable;
                    score = Math.min(player.megaCredits - maxMegacreditsSpendable, player.steel, player.titanium, player.plants, player.energy, player.heat - balance);
                }
            }
        }
        return score;
    }
    canClaim(player) {
        return this.getScore(player) >= 2;
    }
}
exports.Merchant = Merchant;
//# sourceMappingURL=Merchant.js.map